var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"mapSearch",staticClass:"controls map-search",attrs:{"type":"text","placeholder":"Search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }